import React, { useContext, useRef, useEffect, useState } from "react";
import { Link, PrimaryButton } from "@fluentui/react";
import { css } from "@emotion/css";
import { config } from "../../config";

import MicrosoftLogo from "./MicrosoftLogo";
import { MaximizerContext } from "../../contexts/MaximizerContext";

declare const __webpack_hash__: string | undefined;

const getVersion = () => {
  try {
    const h = __webpack_hash__;
    return h;
  } catch (e) {
    return "development-nobuild";
  }
};

const styles = css`
  position: relative;

  & .footer--helpBot {
    position: absolute;
    left: 16px;
    bottom: 8px;
    height: 32px;
    width: 80px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .footer--confidential {
    color: #e81123;
    font-weight: 600;
  }

  & .footer--privacy-policy {
    padding: 0 20px;
  }

  & .footer--logo {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    & span:last-of-type {
      color: var(--main-font-color, black);
    }
  }

  & .footer--version {
    position: absolute;
    right: 16px;
    font-size: 0.75em;
    color: var(--accent-font-color, gray);
  }
`;


export const Footer: React.FC = () => {
  const { hiddenState, setFooterHeight } = useContext(MaximizerContext);
  const footerRef = useRef<HTMLElement | null>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (footerRef.current) {
      const distances = footerRef.current.getBoundingClientRect();
      setHeight(distances.height);
    }
  }, []);

  useEffect(() => {
    setFooterHeight(height);
  }, [height]);

  return (
    <footer className={styles} hidden={hiddenState} ref={footerRef}>
<PrimaryButton
  ariaDescription="Finance Assistant"
  className="footer--helpBot"
  aria-label="Finance Assistant"
  title="Finance Assistant"
    onClick={() => {
              (window as any).open(config.get("hostappid"), "_blank");
            }}
>
  <div style={{ width: "180%", height: "180%" }}>
    <MicrosoftLogo color="sparkle"  />
  </div>
</PrimaryButton>
      <span className="footer--confidential">Microsoft Confidential</span>
      <Link
        className="footer--privacy-policy"
        target="_blank"
        href="https://microsoft.sharepoint.com/teams/msdpn/SitePages/default.aspx"
      >
        Privacy Policy
      </Link>
      <div className="footer--logo">
        <MicrosoftLogo color="gray" />
        <span> © 2014 - 2019 Microsoft </span>
      </div>
      <span className="footer--version">Version: {getVersion()}</span>
    </footer>
  );
};

export default Footer;
